

import { momentClient } from "@/utils/axios";
import paths from "@/utils/paths";


// 获取保利威签名
export function fetchPolyvSignApi() : any {
  return momentClient.get(paths.market() + '/polyv/sign/video')
}